import React, { useState, useEffect } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  Divider,
  ListItemIcon,
  Badge,
  Tooltip,
  Modal
} from "@mui/material";
import WeatherIcon from "assets/svgIcons/WeatherAlertIcon";
import { ReactComponent as Maps } from "../../assets/images/sidenav/MapIcon.svg";
import { ReactComponent as Fleet } from "../../assets/images/sidenav/FleetIcon.svg";
import { ReactComponent as Message } from "../../assets/images/sidenav/MessageIcon.svg";
import { ReactComponent as Pace } from "../../assets/images/sidenav/PaceIcon.svg";
import { ReactComponent as Ads } from "../../assets/images/sidenav/AdsIcon.svg";
import { ReactComponent as FB } from "../../assets/images/sidenav/F&BIcon.svg";
import { ReactComponent as Pins } from "../../assets/images/sidenav/PinsIcon.svg";
import PeopleIcon from "../../assets/svgIcons/SideNav/PeopleIcon";
import { AdminSideNavIcon } from "assets/svgIcons/AdminSideNavIcon";
import {
  getFeatureSetOption,
  getFeaturesList,
  isUserAdmin,
  isUserReadOnly,
  featureKey
} from "../../constant";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch } from "react-redux";
import { PopUpContainer } from "assets/css/globle";
import { LicenseInfo } from '@mui/x-license';
import {
  MapSideNavComponent,
  FleetSideNavComponent,
  MessagesSideNavComponent,
  PaceSideNavComponent,
  AdsSideNavComponent,
  FBSideNavComponent,
  PinsSideNavComponent,
  AdminSideNavComponent,
  PeopleSideNavComponent
} from "../../commonComponents/SideNav/subSideNav/index";
import { CHECKBOX_LOADER } from "../../globalStore/globalStore";

import { useHookstate } from "@hookstate/core";
import {
  SIDENAV_GLOBAL_STATE,
  SITELOCATION_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  FLEET_GLOBAL_STATES,
  ADS_GLOBAL_STATE,
  FB_GLOBAL_STATES,
  COMMON_COMPONENTS_STATES,
  COP_GLOBAL_STATES,
  MAP_GLOBAL_STATES
} from "globalStore/globalStore";
import { NavLink, useLocation } from "react-router-dom";
import {
  Container,
  SubSideNav,
  SideNavWrapper,
  WeatherIconWrapper,
} from "commonComponents/SideNav/sidenavStyled";
import { useSelector } from "react-redux";
import DashboardIcon from "assets/svgIcons/DashBoardIcon";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import useInboxMessagesCount from "customHooks/useInboxMessagesCount";
const Sidenav = React.memo(function () {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const location = useLocation();

  const [modalOpener, setModalOpener] = useState(false);
  const {
    siteSettingsData,
    getUserRole,
    getFoodOrdersTabDataState,
    FleetSettingslData,
    getFeatureSetState
  } = useSelector((state) => state.commonReducers) || [];

  const { subNavDataState, sideDrawerState, sideDrawerActiveTabState } = useHookstate(SIDENAV_GLOBAL_STATE);
  const { showTagCarsState } = useHookstate(COMMON_COMPONENTS_STATES);
  const { siteLocationGlobalData } = useHookstate(SITELOCATION_GLOBAL_STATE);
  const { siteId, selectSite, hideSubNav } = useHookstate(SITEID_GLOBAL_STATE);
  const { badgeCount } = useHookstate(FLEET_GLOBAL_STATES);
  const { redirectState, alertMsg, nextTabIndex, nextStageName } = useHookstate(ADS_GLOBAL_STATE);
  const { actionZoneModified, refreshActionZones } = useHookstate(MAP_GLOBAL_STATES);
  const {
    nextMainTabIndex,
    nextMainTabName
  } = useHookstate(COP_GLOBAL_STATES);

  const { siteIdData } = useSelector((state) => state.firstReducer);
  const [getPathState, setGetPathState] = useState("");
  const [clickedSameMenu, setclickedSameMenu] = useState(false);
  const [isCommercial, setIsCommercial] = useState(false);
  const [isGolf, setIsGolf] = useState(false);

  let getLocalSubState = JSON.parse(localStorage.getItem("subNavState"));

  const { fbOrdersSettings, foodOrdersCourseFilter } = useHookstate(FB_GLOBAL_STATES);
  const [foodOrdersCourses, setFoodOrdersCourses] = useState([]);
  const { msgInboxCount } = useInboxMessagesCount();

  const [timeoutId, setTimeoutId] = useState(null);

  function resetTimer(flag = "") {
    if (
      sideDrawerActiveTabState.get() === 0 ||
      sideDrawerActiveTabState.get() === 1 ||
      subNavDataState.get() === "MAP" ||
      subNavDataState.get() === "Map"
    ) {
      return;
    } else if (window.innerWidth > 850) {
      hideSubNav.set(true);
      clearTimeout(timeoutId);
      if (flag !== "mouseEnter") {
        setTimeoutId(setTimeout(hideSidebar, 5000));
      }
    }
  }

  function hideSidebar() {
    hideSubNav.set(false);
  }

  const handleMouseEnter = () => {
    resetTimer("mouseEnter");
  };

  const handleMouseLeave = () => {
    resetTimer();
  };

   useEffect(() => {
      if(getFeatureSetState && Object.keys(getFeatureSetState).length > 0) {
        var featureSet = getFeatureSetState?.featureSets?.find(x => x.active);
        setIsCommercial(featureSet?.features?.indexOf(featureKey.resortEdition) >= 0);
        setIsGolf(featureSet?.features?.indexOf(featureKey.golf) >= 0);
      } 
    }, [siteId.get(), getFeatureSetState]);

  useEffect(() => {
    clearInterval(timeoutId);
    setclickedSameMenu(false)
    if (window.innerWidth <= 850 && subNavDataState.get().toLowerCase() !== "map") {
      let intervals = setInterval(() => {
        sideDrawerState.set(false);
        hideSubNav.set(false);
      }, 20000);
      return () => {
        clearInterval(intervals);
      };
    } else {
      resetTimer();
      return () => {
        clearInterval(timeoutId);
      };
    }
    
  }, [sideDrawerActiveTabState.get(), clickedSameMenu]);

  const hideSubSideNav = (textItem) => {
    if (textItem === "MAP") {
      hideSubNav.set(false);
      setTimeout(() => {
        hideSubNav.set(true);
      });
    } else if (
      window.innerWidth <= 850 &&
      subNavDataState.get().toLowerCase() !== "map"
    ) {
      setTimeout(() => {
        hideSubNav.set(false);
      }, 20000);
      setTimeout(() => {
        hideSubNav.set(true);
      });
    } else {
      hideSubNav.set(true);
    }
  };

  const handleEvent = () => {
    let name = location.pathname.split("/");
    localStorage.setItem("subNavDataState", name[1]);
    if (subNavDataState.get().toLowerCase() === "dashboard") {
      localStorage.setItem("sideDrawerActiveTabState", 0);
      sideDrawerActiveTabState.set(0);
    } else if (subNavDataState.get().toLowerCase() === "map") {
      localStorage.setItem("sideDrawerActiveTabState", 1);
      sideDrawerActiveTabState.set(1);
    } else if (subNavDataState.get().toLowerCase() === "fleet") {
      localStorage.setItem("sideDrawerActiveTabState", 2);
      sideDrawerActiveTabState.set(2);
    } else if (subNavDataState.get().toLowerCase() === "messages") {
      localStorage.setItem("sideDrawerActiveTabState", 3);
      sideDrawerActiveTabState.set(3);
    } else if (subNavDataState.get().toLowerCase() === "pace") {
      localStorage.setItem("sideDrawerActiveTabState", 4);
      sideDrawerActiveTabState.set(4);
    } else if (subNavDataState.get().toLowerCase() === "ads") {
      localStorage.setItem("sideDrawerActiveTabState", 5);
      sideDrawerActiveTabState.set(5);
    } else if (subNavDataState.get().toLowerCase() === "pins") {
      localStorage.setItem("sideDrawerActiveTabState", 7);
      sideDrawerActiveTabState.set(7);
    } else if (subNavDataState.get().toLowerCase() === "foodandbeverages") {
      localStorage.setItem("sideDrawerActiveTabState", 6);
      sideDrawerActiveTabState.set(6);
    } else if (subNavDataState.get().toLowerCase() === "admin") {
      localStorage.setItem("sideDrawerActiveTabState", 8);
      sideDrawerActiveTabState.set(8);
    }
  };

  useEffect(() => {
    handleEvent();
  }, [subNavDataState.get(), sideDrawerActiveTabState.get()]);

  useEffect(() => {
    weatherAlertGlobalState.set(
      siteSettingsData?.WeatherAlert
    );
    LicenseInfo.setLicenseKey('20c03c0276ab7bff5e33ecddc28c07eaTz0xMDE1MDcsRT0xNzYyNzA3NDc1MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=');
  }, [siteSettingsData]);
  
  useEffect(() => {
    startGettingFoodOrders();
  }, [siteId.get(), siteSettingsData, getFoodOrdersTabDataState]);

  useEffect(() => {
    pendingFoodOrdersCount();
  }, [getFoodOrdersTabDataState, siteId.get(), foodOrdersCourses, pendingFoodOrdersCount()]);

  function startGettingFoodOrders() {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      let tempData = [];

      siteSettingsData?.Courses.forEach(function (course) {
        // if we have saved away an active setting for this course use it.
        let isActiveCourse = true;
        if (foodOrdersCourseFilter.get().courseFilters) {
          isActiveCourse = _.result(
            _.find(foodOrdersCourseFilter.get().courseFilters, {
              number: course?.Number,
            }),
            "active",
            true
          );
        }

        // Set up the initial values for which courses orders will be shown
        let viewCourseActive = {
          number: course?.Number,
          name: course?.Name,
          active: isActiveCourse,
        };
        tempData.push(viewCourseActive);
      });

      setFoodOrdersCourses(tempData);
    }
  }

  function pendingFoodOrdersCount() {
    return getFoodOrdersTabDataState &&
      getFoodOrdersTabDataState.length !== 0 &&
      foodOrdersCourses &&
      foodOrdersCourses.length !== 0
      ? getFoodOrdersTabDataState?.filter((order) => {
          let isActiveCourse = _.find(foodOrdersCourses, {
            number: order?.Course,
          })?.active;
          return !order.FulfilledDate && isActiveCourse;
        }).length
      : 0;
  }

  const showWeatherAlert = () => {
    if (weatherAlertGlobalState.get()) {
      weatherAlertPopUpDisplayer.set(false);
      dispatch(
        COMMON_SERVICES.putFleetSettingsServices2({
          code: "WA",
          Value: false,
        }, siteId.get())
      );
      weatherAlertGlobalState.set(false);
    } else {
      weatherAlertPopUpDisplayer.set(true);
    }
  };

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
  }, [FleetSettingslData?.WeatherAlert]);

  function handleAlertClick(identification, alertDetector) {
    if (alertDetector) {
      weatherAlertGlobalState.set(alertDetector);
      LoadingState.set(true);
      dispatch(
        COMMON_SERVICES.putFleetSettingsServices2({
          code: identification,
          Value: alertDetector,
        }, siteId.get())
      );

      setTimeout(() => {
        LoadingState.set(false);
      }, 2000);
      weatherAlertPopUpDisplayer.set(false);
    } else {
      weatherAlertGlobalState.set(alertDetector);
      LoadingState.set(true);
      dispatch(
        COMMON_SERVICES.putFleetSettingsServices2({
          code: identification,
          Value: false,
        }, siteId.get())
      );
      setTimeout(() => {
        LoadingState.set(false);
      }, 2000);
      weatherAlertPopUpDisplayer.set(false);
    }
  }
  
  useEffect(() => {
    if (getLocalSubState !== null) {
      hideSubNav.set(getLocalSubState);
    }
  }, []);

  const {
    weatherAlertGlobalState,
    weatherAlertPopUpDisplayer
  } = useHookstate(FLEET_GLOBAL_STATES);

  const { LoadingState } = useHookstate(CHECKBOX_LOADER);

  const showPopupBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "400px",
      width: "calc(100% - 40px)",
      bgcolor: "#fff",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={weatherAlertPopUpDisplayer.get()}
        onClose={() => weatherAlertPopUpDisplayer.set(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Engage_weather_alert?")}</p>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button
                onClick={() => handleAlertClick("WA", true)}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button onClick={() => handleAlertClick("WA", false)}>
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  const sidenavOptions = [
    { id: 0, textItem: t("Dashboard"), path: "/dashboard", disabled: false, isVisible: true },
    { id: 1, textItem: "Map", path: "/map", disabled: false, isVisible: true },
    {
      id: 2,
      textItem: "Fleet",
      path: "/fleet",
      disabled: !siteIdData,
      isVisible: true
    },
    {
      id: 9,
      textItem: "People",
      path: "/people",
      disabled: !siteIdData,
      isVisible: isCommercial
    },
    {
      id: 3,
      textItem: "Messages",
      path: "/messages",
      disabled: !siteIdData,
      isVisible: true
    },
    {
      id: 4,
      textItem: "Pace",
      path: "/pace",
      disabled: !siteIdData,
      isVisible: !isCommercial
    },
    {
      id: 5,
      textItem: "Ads",
      path: "/ads",
      disabled: !siteIdData,
      isVisible: true
    },
    {
      id: 6,
      textItem: "foodandbeverages",
      path: "/foodandbeverages",
      disabled: false,
      isVisible: !isCommercial
    },
    {
      id: 7,
      textItem: "Pins",
      path: "/pins",
      disabled: !isGolf || !siteIdData,
      isVisible: !isCommercial
    },
    {
      id: 8,
      textItem: "Admin",
      path: "/admin",
      disabled: !siteIdData,
      isVisible: true
    },
  ];

  useEffect(() => {
    sideDrawerActiveTabState.set(
      localStorage.getItem("sideDrawerActiveTabState")
    );
    subNavDataState.set(localStorage.getItem("subNavDataState"));
    if(siteId.get() === null ){
      siteLocationGlobalData.set(true)
    }
  }, []);

  const placeIcon = (text) => {
    switch (text.toLowerCase()) {
      case "dashboard":
        return <DashboardIcon />;
      case "map":
        return <Maps />;
      case "fleet":
        return <Fleet />;
      case "messages":
        return <Message />;
      case "pace":
        return <Pace />;
      case "ads":
        return <Ads />;
      case "foodandbeverages":
        return <FB />;
      case "pins":
        return <Pins />;
      case "people":
        return <PeopleIcon />;
      case "admin":
        return <AdminSideNavIcon />;
    }
  };

  const showSubNav = () => {
    switch (subNavDataState.get().toLowerCase()) {
      case "map":
        return <MapSideNavComponent />;
      case "fleet":
        return <FleetSideNavComponent />;
      case "messages":
        return <MessagesSideNavComponent />;
      case "pace":
        return <PaceSideNavComponent />;
      case "people":
          return <PeopleSideNavComponent />;
      case "ads":
        return <AdsSideNavComponent />;
      case "foodandbeverages":
        return (
          <FBSideNavComponent
            pendingFoodOrderCountVal={pendingFoodOrdersCount()}
          />
        );
      case "pins":
        return <PinsSideNavComponent />;
      case "admin":
        return <AdminSideNavComponent />;
    }
  };

  const showDiscardModal = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 510,
      bgcolor: "#fff",
      borderRadius: "5px",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "63px 10px 45px",
    };

    return (
      <Modal
        open={modalOpener}
        onClose={() => setModalOpener(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Discard_changes_to_campaign")}?</p>
            <div className="action-btn">
              <button
                className="primary"
              >
                {t("Yes")}
              </button>
              <button
              >
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  useEffect(() => {
    let getUrl = window.location.pathname.split("/");
    let getPath = getUrl[1].toUpperCase();
    setGetPathState(getPath);
  }, [subNavDataState.get()]);

  return (
    <>
      <Container
        className={
          sideDrawerState.get()
            ? "sidenav-wrapper active"
            : "sidenav-wrapper un-active"
        }
      >
        {sideDrawerState.get() ? (
          <>
            <div
              className="outside-click"
              onClick={() => {
                sideDrawerState.set(false);
                hideSubNav.set(false);
              }}
            />
            <List
              sx={{
                width: 78.5,
                boxShadow: "2px 0px 3px rgba(0,0,0,0.25)",
                paddingTop: "0",
                overflow: "auto",
              }}
            >
              {sidenavOptions?.length !== 0 && sidenavOptions?.filter((item) => {
                    if (item.isVisible && (item.textItem !== "Admin" || isUserAdmin(getUserRole && getUserRole?.Role))) {
                      if (item.textItem !== "Pace" || (item.textItem === "Pace" &&
                          !getFeatureSetOption(
                            siteSettingsData && siteSettingsData?.Features,
                            getFeaturesList().real_time_tracking
                          ) &&
                          getUserRole &&
                          getUserRole?.Role !== 6)
                      ) {
                        return item;
                      }
                    }
                  })
                  .map((text) => (
                    <Tooltip
                      key={text.id}
                      title={
                        text.textItem !== "foodandbeverages"
                          ? t(text.textItem)
                          : t("FoodAndBeverages")
                      }
                      placement="bottom-end"
                      arrow
                    >
                      <SideNavWrapper
                        key={text.id}
                        className={text.textItem}
                        onClick={(e) => {
                          if (actionZoneModified.get()) {
                            refreshActionZones.set(true);
                            nextMainTabIndex.set(text.id);
                            nextMainTabName.set(text.textItem);
                            e.preventDefault();
                          } else if (redirectState.get()) {
                            alertMsg.set(true);
                            nextTabIndex.set(text.id);
                            e.preventDefault();
                          } else {
                            if (JSON.parse(siteLocationGlobalData.get()) === true) {
                              e.preventDefault();
                            } else {
                              hideSubSideNav(text.textItem);
                              localStorage.setItem(
                                "sideDrawerActiveTabState",
                                text.id
                              );
                              localStorage.setItem("subNavState", "true");
                              sideDrawerActiveTabState.set(text.id);
                              setclickedSameMenu(true);
                            }
                          }
                        }}
                        style={{
                          background:
                            (sideDrawerActiveTabState.get() == text.id &&
                              sideDrawerActiveTabState.get() !== 8) ||
                            getPathState === text.textItem
                              ? "var(--theme-background)"
                              : text.textItem === "Admin"
                              ? "var(--admin-tab-bg)"
                              : "transparent",
                        }}
                      >
                        {text.id === 3 &&
                        msgInboxCount != 0 &&
                        !siteLocationGlobalData.get() ? (
                          <span className="message-count">{msgInboxCount}</span>
                        ) : (
                          <></>
                        )}
                        {text.id === 6 &&
                        fbOrdersSettings.get().fillOrdersHere &&
                        !siteLocationGlobalData.get() &&
                        pendingFoodOrdersCount() != 0 ? (
                          <span className="message-count">
                            {pendingFoodOrdersCount()}
                          </span>
                        ) : (
                          <></>
                        )}
                        <NavLink
                          to={text.path}
                          style={{ textDecoration: "none" }}
                        >
                          {text.textItem !== "Fleet" ? (
                            <ListItem>
                              <ListItemButton
                                disabled={
                                  siteLocationGlobalData.get() ||
                                  siteId.get() === null || text.disabled
                                }
                                sx={{
                                  minWidth: 50,
                                  justifyContent: "center",
                                  flexDirection: "column",
                                  display: "flex",
                                  minHeight: "40px",
                                  backgroundColor:
                                    (subNavDataState.get() === text.textItem &&
                                      subNavDataState.get() !== "Admin") ||
                                    getPathState === text.textItem
                                      ? "var(--theme-background)"
                                      : text.textItem === "Admin"
                                      ? "var(--admin-tab-bg)"
                                      : "transparent",
                                }}
                                onClick={(e) => {
                                if (actionZoneModified.get()) {
                                  refreshActionZones.set(true);
                                  nextMainTabIndex.set(text.id);
                                  nextMainTabName.set(text.textItem);
                                  e.preventDefault();
                                } else if (redirectState.get()) {
                                  alertMsg.set(true);
                                  nextStageName.set(text.textItem);
                                  e.preventDefault();
                                } else {
                                  if (
                                    JSON.parse(siteLocationGlobalData.get()) ===
                                    true
                                  ) {
                                    e.preventDefault();
                                  } else {
                                    localStorage.setItem(
                                      "subNavDataState",
                                      text.textItem
                                    );
                                    subNavDataState.set(text.textItem);
                                  }
                                }
                              }}
                            >                       
                                <ListItemIcon
                                  sx={{
                                    minWidth: 50,
                                    justifyContent: "center",
                                  }}
                                >
                                  {placeIcon(text.textItem)}
                                </ListItemIcon>
                         
                              </ListItemButton>       
                            </ListItem>
                          ) : (
                            <Badge
                              badgeContent={badgeCount.value}
                              color="error"
                              invisible={selectSite.get()}
                            >
                             <ListItem> 
                              <ListItemButton
                                sx={{
                                  minWidth: 50,
                                  justifyContent: "center",
                                  flexDirection: "column",
                                  display: "flex",
                                  paddingTop: 2,
                                  minHeight: "70px",
                                  backgroundColor:
                                    (subNavDataState.get() === text.textItem &&
                                      subNavDataState.get() !== "Admin") ||
                                    getPathState === text.textItem
                                      ? "var(--theme-background)"
                                      : text.textItem === "Admin"
                                      ? "var(--admin-tab-bg)"
                                      : "transparent",
                                }}
                                disabled={siteLocationGlobalData.get()}
                                onClick={(e) => {
                                  if (actionZoneModified.get()) {
                                    refreshActionZones.set(true);
                                    nextMainTabIndex.set(text.id);
                                    nextMainTabName.set(text.textItem);
                                    e.preventDefault();
                                  } else if (redirectState.get()) {
                                    alertMsg.set(true);
                                    nextStageName.set(text.textItem);
                                    e.preventDefault();
                                  } else {
                                    if (
                                      JSON.parse(
                                        siteLocationGlobalData.get()
                                      ) === true
                                    ) {
                                      e.preventDefault();
                                    } else {
                                      localStorage.setItem(
                                        "subNavDataState",
                                        text.textItem
                                      );
                                      subNavDataState.set(text.textItem);
                                    }
                                    showTagCarsState.set(false);
                                  }
                                }}
                              >
                                
                                  <ListItemIcon
                                    sx={{
                                      minWidth: 50,
                                      justifyContent: "center",
                                    }}
                                  >
                                    {placeIcon(text.textItem)}
                                  </ListItemIcon>
                               
                                </ListItemButton> 
                                </ListItem>
                            </Badge>
                          )}
                          <Divider />
                        </NavLink>
                      </SideNavWrapper>
                    </Tooltip>
                  ))}
            </List>
            <SubSideNav
              className={subNavDataState.get()}
              id="sub-side-nav-web"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {hideSubNav.get() ? showSubNav() : <></>}
            </SubSideNav>
          </>
        ) : (
          <></>
        )}

        {showDiscardModal()}
        {sideDrawerState.get() ? (
          <Tooltip title={t("Set_Weather_alert")} placement="bottom-end" arrow>
            <WeatherIconWrapper
              style={{
                cursor: siteLocationGlobalData.get()
                  ? "not-allowed"
                  : "pointer",
              }}
            >
              <IconButton
                disabled={
                  isUserReadOnly(getUserRole && getUserRole.Role) ||
                  siteLocationGlobalData.get()
                }
                onClick={showWeatherAlert}
              >
                <WeatherIcon
                  color={
                    weatherAlertGlobalState.get()
                      ? "var(--weather-alert-color)"
                      : "var(--theme-background)"
                  }
                />
              </IconButton>
            </WeatherIconWrapper>
          </Tooltip>
        ) : (
          <></>
        )}

        {showPopupBox()}
      </Container>
      <SubSideNav className={subNavDataState.get()} id="sub-side-nav-mobile">
        {hideSubNav.get() ? showSubNav() : <></>}
      </SubSideNav>
    </>
  );
});
export { Sidenav };
